import { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { FormatterMoney } from "components/Function";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Tooltip,
  Legend
} from "chart.js";
import { Chart } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Tooltip, Legend);

function ChartSaleTrend({ data = [], type = "Daily" }) {
    const { t } = useTranslation();
    const [mixedChartData, setMixedChartData] = useState(null);
    const [mixedChartOptions, setMixedChartOptions] = useState(null);
    
    useEffect(() => {
        const labels = data.map(d => d._id);
        const sales = data.map(d => d.dailySale);
        const totalRevenue = data.map(d => FormatterMoney({ money: d.totalRevenue, currency: d.currency, currency_to: "USD", type: "number" }));

        setMixedChartData({
            labels,
            datasets: [
                {
                    type: "line",
                    label: "Total Revenue",
                    data: totalRevenue,
                    borderColor: "#E04ACB",
                    backgroundColor: "#E04ACB",
                    fill: true,
                    tension: 0.3,
                    yAxisID: "y",
                    pointRadius: 0,
                    pointHoverRadius: 4,
                },
                {
                    type: "bar",
                    label: type + " Sales",
                    data: sales,
                    backgroundColor: "#4F70FD",
                    yAxisID: "y2",
                }
            ]
        });

        setMixedChartOptions({
            responsive: true,
            interaction: {
                mode: "index",
                intersect: false,
            },
            stacked: false,
            plugins: {
                legend: {
                    position: "bottom",
                    labels: {
                        usePointStyle: true,
                        pointStyle: "circle",
                        boxWidth: 10,
                        boxHeight: 10,
                    },
                },
                tooltip: { enabled: true },
                datalabels: { display: false },
            },
            scales: {
                y: {
                    type: "linear",
                    position: "left",
                    title: {
                        display: true,
                        text: "Total Revenue",
                    },
                    ticks: {
                        callback: value => {
                            if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                            if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                            return value;
                        }
                    },
                    grid: {
                        drawOnChartArea: true,
                    }
                },
                y2: {
                    type: "linear",
                    position: "right",
                    title: {
                        display: true,
                        text: type + " Sales",
                    },
                    ticks: {
                        callback: value => {
                            if (value >= 1_000_000) return (value / 1_000_000).toFixed(1) + "M";
                            if (value >= 1_000) return (value / 1_000).toFixed(1) + "K";
                            return value;
                        }
                    },
                    grid: {
                        drawOnChartArea: false,
                    }
                },
                x: {
                    ticks: {
                        maxRotation: 45,
                        minRotation: 45
                    }
                }
            }
        });
    }, [data, t, type]);

    return (
        <Fragment>
            {mixedChartData && mixedChartOptions && (
                <Chart type="bar" data={mixedChartData} options={mixedChartOptions} />
            )}
        </Fragment>
    );
}

const mapStateToProps = state => ({
});
const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ChartSaleTrend);